module.exports = __webpack_public_path__ + "img/shareBox.a4724fa1.svg";